import type { MaterialTrimmed } from "~/common/interfaces/material-trimmed";

export const getMaterialDefault = (): MaterialTrimmed => ({
	id: 0,
	name: "",
	colors: []
});
